import { Dispatch, SetStateAction } from 'react';
import { BaseRequest } from 'src/api/hooks/useApi.types';
import {
  FacebookGroupPayload,
  ScheduleFacebookPostPayload,
  UpdateScheduledFacebookPostPayload,
} from 'src/api/hooks/useFacebookPost.types';
import { GenerateFacebookPostPayload } from 'src/api/hooks/useJob.types';
import { FacebookPost, FacebookPostRotation, PostSchedule } from 'src/DTO/FacebookPost.type';
import { Job } from 'src/DTO/Job.type';

export enum PostScheduleStatus {
  INACTIVE = 'Inactive',
  ACTIVE = 'Active',
}

export interface ScheduleFacebookPostStep3Props {
  postSchedule: PostSchedule;
  onSubmit: (updatedDetails: PostSchedule) => void;
  handlePreviousButtonClick: () => void;
  handleMoveToNextStep: () => void;
  pageOptions: string[];
  groupOptions: string[];
  pageData: PageData[];
  setPageData: Dispatch<SetStateAction<PageData[]>>;
  groupData: GroupData[];
  setGroupData: Dispatch<SetStateAction<GroupData[]>>;
  handleAuthSuccess: (accessToken: string) => void;
  authFacebookPagesLoading: boolean;
  getConnectedFacebookPagesLoading: boolean;
  setIsLogged: Dispatch<SetStateAction<boolean>>;
  populatedPageData: PageData[];
  populatedGroupData: GroupData[];
  isLogged: boolean;
  jobId: string;
  addFacebookGroups: BaseRequest<FacebookGroupPayload>;
}

export interface ScheduleFacebookPostStep2Props {
  selectedJob: Job;
  onSubmit: (updatedDetails: PostSchedule) => void;
  handlePreviousButtonClick: () => void;
  handleMoveToNextStep: () => void;
  postSchedule: PostSchedule;
  fbPosts: FacebookPost[];
}

export interface ScheduleFacebookPostStep1Props {
  imageLoading: boolean[];
  textLoading: boolean[];
  getFbPostLoading: boolean;
  generatedText: string;
  fbPosts: FacebookPost[];
  selectedJob: Job;
  onCancel: () => void;
  handleMoveToNextStep: () => void;
  setImageLoading: Dispatch<SetStateAction<boolean[]>>;
  setTextLoading: Dispatch<SetStateAction<boolean[]>>;
  generateFbPost: BaseRequest<GenerateFacebookPostPayload>;
  setFbPosts: Dispatch<SetStateAction<FacebookPost[]>>;
  generateFbPostLoading: boolean;
  facebookPosts: FacebookPostRotation[];
  redirectedJobId?: string;
  setPostSchedule: Dispatch<React.SetStateAction<PostSchedule>>;
}

export interface ConfirmFacebookPostScheduleProps {
  handleClose: () => void;
  handlePreviousButtonClick: () => void;
  handleMoveToNextStep: () => void;
  postSchedule: PostSchedule;
  fbPosts: FacebookPost[];
  setSchedulePosts: Dispatch<SetStateAction<PostSchedule[]>>;
  scheduleFacebookPost: BaseRequest<ScheduleFacebookPostPayload>;
}

export interface UpdateFacebookPostScheduleProps {
  isScheduleUpdateDialogOpen: boolean;
  setPostDetails: Dispatch<SetStateAction<PostSchedule[]>>;
  selectedPostSchedule: Readonly<PostSchedule>;
  setIsScheduleUpdateDialogOpen: Dispatch<SetStateAction<boolean>>;
  updateScheduledPost: BaseRequest<UpdateScheduledFacebookPostPayload>;
}

export interface CreateFacebookPostScheduleProps {
  open: boolean;
  setOpen: (isOpen: boolean) => void;
  selectedJob: Job;
  setSchedulePosts: Dispatch<SetStateAction<PostSchedule[]>>;
  scheduleFacebookPost: BaseRequest<ScheduleFacebookPostPayload>;
  getScheduledPosts: BaseRequest<null>;
  getJobs: BaseRequest<null>;
  redirectedJobId?: string;
}

export interface ThankYouPageProps {
  handleClose: () => void;
}

export interface PageData {
  id: string;
  name: string;
  url: string;
}

export type GroupData = Pick<PageData, 'name' | 'url'>;

export interface AddFacebookGroup {
  groupName: string;
  groupURL: string;
  errors: {
    groupName: boolean;
    groupURL: boolean;
  };
}
